import { create } from 'zustand';
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import { persist } from 'zustand/middleware';

export const useSearchContractsStore = create()(
    persist(
        (set) => ({
            refetchSearchContracts: false,
            storeRefetchSearchContracts: (refetchSearchContracts) => set(() => ({ refetchSearchContracts: refetchSearchContracts })),
            querySearchContracts: getInitialQuery(),
            storeQuerySearchContracts: (querySearchContracts) => set(() => ({ querySearchContracts: querySearchContracts }))
        }),
        {
            name: 'search-contracts-storage'
        }
    )
);

export default useSearchContractsStore;